import {
	getController,
	apiService as Service,
	type HpRequestPostPut,
} from '@/services/service'

const url = 'mailtemplates'

export const mailTemplateService = {
	...getController<
		Api.MailTemplate,
		Api.MailTemplatePostInput,
		Api.MailTemplatePostInput
	>(url),
	update: (id: number, data: HpRequestPostPut<Api.MailTemplatePostInput>) =>
		Service.put<Api.MailTemplate>({
			url: `${url}/${id}`,
			...data,
		}),
}

export default mailTemplateService
